export interface ParticipantsAccessContext {
  participantsListEnabled: boolean;
  canSeeParticipantsPanel: boolean;
  breakoutRoomsEnabled: boolean;
  canManageBreakout: boolean;
  breakoutStatus: string;
  breakoutFreeMovement: boolean;
  isSystemSession: boolean;
}

// A roster is not recording content; the panel body renders nothing for a system session anyway.
export const canAccessParticipants = (ctx: ParticipantsAccessContext): boolean => {
  if (ctx.isSystemSession) {
    return false;
  }

  const hasBreakoutManagementAccess = ctx.breakoutRoomsEnabled && ctx.canManageBreakout;
  const breakoutsFreeMovementAvailable =
    ctx.breakoutRoomsEnabled && ctx.breakoutStatus === 'started' && ctx.breakoutFreeMovement;

  return (
    ctx.participantsListEnabled &&
    (ctx.canSeeParticipantsPanel || hasBreakoutManagementAccess || breakoutsFreeMovementAvailable)
  );
};
